<template>
  <div class="schedule-card-new">
    <!-- 第一行：时间选择框和年月显示 -->
    <div class="header-row">
      <div class="date-picker-section">
        <el-date-picker
          v-model="selectedDate"
          type="date"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="handleDateChange"
          size="small"
          style="width: 130px;"
        />
      </div>
      
      <!-- 修改：添加年月切换控件 -->
      <div class="month-display">
        <span class="nav-icon prev-month" @click="prevMonth">◀</span>
        <span class="current-month">{{ currentMonth }}</span>
        <span class="nav-icon next-month" @click="nextMonth">▶</span>
      </div>
    </div>
    
    <!-- 主内容区域：左侧月视图 + 右侧异常合同列表 -->
    <div class="main-content">
      <!-- 左侧：月视图日历 -->
      <div class="calendar-section">
        <!-- 星期标题 -->
        <div class="weekdays">
          <div v-for="day in weekdays" :key="day" class="weekday-cell">
            {{ day }}
          </div>
        </div>
        
        <!-- 日历网格 -->
        <div class="calendar-grid">
          <div v-for="day in calendarDays" :key="day.date" 
              class="calendar-day" 
              :class="getDayClass(day)"
              @click="selectDate(day)">
            <!-- 左上角显示日期 -->
            <!-- 左上角：圆圈日期 -->
            <div
              class="day-circle"
              :class="getDayCircleClass(day)"
            >
              {{ day.display }}
            </div>

            <!-- 右下角：异常数量（无圆圈） -->
            <div
              v-if="getExceptionCount(day.date) > 0"
              class="exception-count-text"
            >
              {{ getExceptionCount(day.date) }}
            </div>
          </div>
        </div>
        

      </div>
      
      <!-- 右侧：异常合同列表（保持不变） -->
      <!-- ... 原有代码保持不变 ... -->
      <div class="exception-section">
        <!-- 列表标题 -->
        <div class="exception-header">
          <span class="selected-date">{{ displayDate }} 异常合同</span>
          <span class="exception-count">{{ todayExceptionCount }}个异常</span>
        </div>
        
        <!-- 异常合同列表 -->
        <div class="exception-list-container">
          <div v-if="todayExceptionContracts.length > 0" class="exception-list">
            <div
              v-for="(item, index) in todayExceptionContracts"
              :key="index"
              class="exception-item"
              @click="showExceptionDetail(item)"
            >
              <!-- 第一行：时间 + 异常类型 -->
              <div class="item-main">
                <span class="contract-no">{{ item.time }}</span>
                <span class="exception-type">{{ item.type }}</span>
              </div>

              <!-- 第二行：内容 -->
              <div
                class="item-sub"
                @click.stop="copyTaskOrContractNo(item)"
                :title="'点击复制合同编号/项目编号'"
              >
                <span class="exception-content">{{ item.content }}</span>
                <!-- <span class="create-time">{{ item.time }}</span> -->
              </div>
            </div>
          </div>

          <div v-else class="no-exception">
            <div class="no-exception-text">当日无异常合同</div>
          </div>
        </div>
        

      </div>      
    </div>
  </div>
</template>

<script>
import { getAbnormalDateList } from '@/api/mainapi.js';

export default {
  name: 'ScheduleCardNew',
  data() {
    return {
      // 选中的日期
      selectedDate: this.formatLocalDate(new Date()),
      
      // 日历数据
      calendarDays: [],
      
      // 异常合同数据
      todayExceptionContracts: [],
      
      // 星期标题
      weekdays: ['一', '二', '三', '四', '五', '六', '日'],
      
      // 日期选择器配置
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      
      // 新增：异常数据缓存
      exceptionDataCache: {},
      requestedMonths: new Set(),// ✅ 记录已请求过的月份

      
      // 新增：当前查看的月份
      currentViewMonth: null
    };
  },
  computed: {
    // 当前年月显示
    currentMonth() {
      if (!this.currentViewMonth) {
        const date = new Date(this.selectedDate);
        return `${date.getFullYear()}年${date.getMonth() + 1}月`;
      }
      const date = new Date(this.currentViewMonth);
      return `${date.getFullYear()}年${date.getMonth() + 1}月`;
    },

    // 显示日期格式
    displayDate() {
      if (!this.selectedDate) return '';
      const date = new Date(this.selectedDate);
      return `${date.getMonth() + 1}月${date.getDate()}日`;
    },
    
    // 今日异常合同数量
    todayExceptionCount() {
      return this.todayExceptionContracts.length;
    },    
    
    // 判断是否为移动端视图
    isMobileView() {
      // return window.innerWidth < 768; // 可以根据需要调整断点
      return false; // 可以根据需要调整断点
    }
  },
  created() {
    this.initData();
  },
  methods: {
getDayCircleClass(day) {
  const cls = [];

  if (!day.isCurrentMonth) {
    cls.push('other-month');
  }

  if (this.getExceptionCount(day.date) > 0) {
    cls.push('has-exception');
  }

  if (day.date === this.selectedDate) {
    cls.push('selected');
  }

  return cls;
},

// 获取当前月视图的第一天和最后一天
getMonthRange(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = d.getMonth();

  // const startDate = new Date(year, month -1, 22);
  // const endDate = new Date(year, month + 1, 7);
  const startDate = new Date(year, month -1, 22);
  const endDate = new Date(year, month + 1, 7);
  return {
    startDate: this.formatLocalDate(startDate),
    endDate: this.formatLocalDate(endDate)
  };
},

// 加载异常数据（替换原来的 mock）
async loadExceptionDataFromApi(startDate, endDate) {
  try {
    const res = await getAbnormalDateList({
      startDate,
      endDate
    });

    if (res.data.code === 200) {
      const rawMap = res.data.data.information || {};

      const formattedCache = {};

      Object.keys(rawMap).forEach(date => {
        formattedCache[date] = rawMap[date].map(item => {
          // ✅ 后端对「空」的表达不统一：有时是 ''，有时是 ' '（单个空格）
          //    统一先 trim 再判断 —— 空格在 JS 里是 truthy，
          //    filter(Boolean) 滤不掉、|| '' 也兜不住，不 trim 就会被当成有值
          const contractNo = (item['合同编号'] || '').trim();
          const taskNo = (item['任务号'] || '').trim();
          // ✅ 合同号、任务号都是空（'' 和 ' ' 都算空）时，用「项目编号」顶上
          const projectNo = (!contractNo && !taskNo)
            ? (item['项目编号'] || '').trim()
            : '';

          return {
            time: item['发生时间']
              ? item['发生时间'].substring(0, 10)
              : date,
            type: item['异常类型'] || '',
            contractNo,
            taskNo,
            // ✅ 存一份项目编号：点击复制时同样能顶上（与显示逻辑一致）
            projectNo,
            // ✅ 编号部分：有合同号/任务号 → 照旧两个都放；两个都没有 → 只放项目编号
            content: [
              ...((contractNo || taskNo) ? [contractNo, taskNo] : [projectNo]),
              item['相关节点人'],
              item['事件详情']
            ]
              .filter(Boolean)
              .join(' | ')
          };
        });
      });

      this.exceptionDataCache = {
        ...this.exceptionDataCache,
        ...formattedCache
      };
    }
  } catch (err) {
    console.error('异常数据接口异常', err);
  }
},

    // 日期格式化方法
    formatLocalDate(date) {
      if (!date) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    // 初始化数据
    async initData() {
      const today = new Date();
      this.currentViewMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      await this.generateCalendar();
      await this.loadSelectedDateExceptionData();
    },
    
    // 生成日历
async generateCalendar() {
  if (!this.currentViewMonth) return;

  const date = new Date(this.currentViewMonth);
  const year = date.getFullYear();
  const month = date.getMonth();

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const firstDayIndex = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;
  const daysInMonth = lastDay.getDate();

  this.calendarDays = [];

  // 上月补位
  for (let i = firstDayIndex; i > 0; i--) {
    const prevDate = new Date(year, month, -i + 1);
    this.calendarDays.push({
      date: this.formatLocalDate(prevDate),
      display: prevDate.getDate(),
      isCurrentMonth: false
    });
  }

  // 当月
  for (let i = 1; i <= daysInMonth; i++) {
    const currentDate = new Date(year, month, i);
    this.calendarDays.push({
      date: this.formatLocalDate(currentDate),
      display: i,
      isCurrentMonth: true
    });
  }

  // 固定 35 格
  if (this.calendarDays.length > 35) {
    this.calendarDays = this.calendarDays.slice(0, 35);
  } else {
    const remain = 35 - this.calendarDays.length;
    for (let i = 1; i <= remain; i++) {
      const nextDate = new Date(year, month + 1, i);
      this.calendarDays.push({
        date: this.formatLocalDate(nextDate),
        display: i,
        isCurrentMonth: false
      });
    }
  }

  // ✅ 跨月缓存处理
  await this.loadMissingExceptionData();
},
    
async loadMissingExceptionData() {
  const missingDates = this.calendarDays
    .map(d => d.date)
    .filter(date => !this.exceptionDataCache.hasOwnProperty(date));

  if (missingDates.length === 0) return;

  // 排序
  missingDates.sort();

  const startDate = missingDates[0];
  const endDate = missingDates[missingDates.length - 1];

  // ✅ 检查跨月范围内的所有月份是否都已请求过
  const startYearMonth = startDate.substring(0, 7);
  const endYearMonth = endDate.substring(0, 7);
  const [sy, sm] = startYearMonth.split('-').map(Number);
  const [ey, em] = endYearMonth.split('-').map(Number);
  const totalMonths = (ey - sy) * 12 + (em - sm) + 1;

  // 收集范围内所有月份 key
  const monthKeys = [];
  for (let i = 0; i < totalMonths; i++) {
    let m = sm + i;
    let y = sy;
    if (m > 12) { y += Math.floor((m - 1) / 12); m = ((m - 1) % 12) + 1; }
    monthKeys.push(`${y}-${String(m).padStart(2, '0')}`);
  }

  // 只有当所有涉及的月份都已请求过时才跳过
  const allRequested = monthKeys.every(k => this.requestedMonths.has(k));
  if (allRequested) return;

  monthKeys.forEach(k => this.requestedMonths.add(k));

  await this.loadExceptionDataFromApi(startDate, endDate);
},
    // // 预加载异常数据
    // async preloadExceptionData() {
    //   const dateSet = new Set();
    //   this.calendarDays.forEach(day => {
    //     if (day.date && !this.exceptionDataCache[day.date]) {
    //       dateSet.add(day.date);
    //     }
    //   });
      
    //   // 并发加载所有日期的异常数据
    //   const promises = Array.from(dateSet).map(date => this.loadExceptionDataForDate(date));
    //   await Promise.all(promises);
    // },
    
    // // 加载指定日期的异常数据
    // async loadExceptionDataForDate(date) {
    //   try {
    //     const response = await this.mockFetchExceptionData(date);
    //     this.exceptionDataCache[date] = response.data || [];
    //   } catch (error) {
    //     this.exceptionDataCache[date] = [];
    //   }
    // },
    
    // 获取指定日期的异常数量
    getExceptionCount(date) {
      if (!date || !this.exceptionDataCache[date]) return 0;
      return this.exceptionDataCache[date].length;
    },
    
    // 加载选中日期的异常数据
async loadSelectedDateExceptionData() {
  this.todayExceptionContracts =
    this.exceptionDataCache[this.selectedDate] || [];
},
    
    // 选择日期（修改：只显示异常，不切换月份）
    selectDate(day) {
      this.selectedDate = day.date;
      this.loadSelectedDateExceptionData();
    },
    
    // 切换至上个月
    async prevMonth() {
      if (!this.currentViewMonth) return;
      const date = new Date(this.currentViewMonth);
      date.setMonth(date.getMonth() - 1);
      this.currentViewMonth = date;
      // ✅ 切换月份时清空请求记录，确保每次都请求新数据
      this.requestedMonths.clear();
      await this.generateCalendar();
    },
    
    // 切换至下个月
    async nextMonth() {
      if (!this.currentViewMonth) return;
      const date = new Date(this.currentViewMonth);
      date.setMonth(date.getMonth() + 1);
      this.currentViewMonth = date;
      // ✅ 切换月份时清空请求记录，确保每次都请求新数据
      this.requestedMonths.clear();
      await this.generateCalendar();
    },
    
    // 日期变化处理
    async handleDateChange(date) {
      if (!date) return;
      
      this.selectedDate = date;
      const newDate = new Date(date);
      this.currentViewMonth = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
      await this.generateCalendar();
      await this.loadSelectedDateExceptionData();
    },
    
    // // 模拟API调用（保持不变）
    // mockFetchExceptionData(date) {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       const exceptionData = {
    //         '2026-04-30': [
    //           { id: 1, contractNo: 'HT20260501001', exceptionType: '交付延迟', exceptionContent: '五一节假日影响交付', createTime: '10:30', status: '已处理' }
    //         ],          
    //         '2026-05-01': [
    //           { id: 1, contractNo: 'HT20260501001', exceptionType: '交付延迟', exceptionContent: '五一节假日影响交付', createTime: '10:30', status: '已处理' }
    //         ],
    //         '2026-05-06': [
    //           { id: 3, contractNo: 'HT20260506002', exceptionType: '质量异常', exceptionContent: '客户反馈产品存在质量问题', createTime: '14:20', status: '处理中' },
    //           { id: 3, contractNo: 'HT20260506002', exceptionType: '质量异常', exceptionContent: '客户反馈产品存在质量问题', createTime: '14:20', status: '处理中' },
    //           { id: 3, contractNo: 'HT20260506002', exceptionType: '质量异常', exceptionContent: '客户反馈产品存在质量问题', createTime: '14:20', status: '处理中' },
    //           { id: 3, contractNo: 'HT20260506002', exceptionType: '质量异常', exceptionContent: '客户反馈产品存在质量问题', createTime: '14:20', status: '处理中' },
    //           { id: 3, contractNo: 'HT20260506002', exceptionType: '质量异常', exceptionContent: '客户反馈产品存在质量问题', createTime: '14:20', status: '处理中' },
    //           { id: 3, contractNo: 'HT20260506002', exceptionType: '质量异常', exceptionContent: '客户反馈产品存在质量问题', createTime: '14:20', status: '处理中' },
    //           { id: 2, contractNo: 'HT20260506001', exceptionType: '交付延迟', exceptionContent: '产品交付时间超过约定日期5天', createTime: '10:30', status: '未处理' },
    //           { id: 3, contractNo: 'HT20260506002', exceptionType: '质量异常', exceptionContent: '客户反馈产品存在质量问题', createTime: '14:20', status: '处理中' },
    //           { id: 3, contractNo: 'HT20260506002', exceptionType: '质量异常', exceptionContent: '客户反馈产品存在质量问题', createTime: '14:20', status: '处理中' },
    //           { id: 4, contractNo: 'HT20260506003', exceptionType: '付款延迟', exceptionContent: '客户未按时支付第三期款项', createTime: '16:45', status: '未处理' }
    //         ],
    //         '2026-05-07': [
    //           { id: 5, contractNo: 'HT20260507001', exceptionType: '发运异常', exceptionContent: '物流运输途中发生异常', createTime: '09:15', status: '已处理' }
    //         ],
    //         '2026-05-10': [
    //           { id: 6, contractNo: 'HT20260510001', exceptionType: '验收异常', exceptionContent: '客户验收不通过，需重新发货', createTime: '11:30', status: '未处理' },
    //           { id: 7, contractNo: 'HT20260510002', exceptionType: '交付延迟', exceptionContent: '原材料供应延迟导致生产延期', createTime: '15:20', status: '处理中' }
    //         ],
    //         '2026-05-15': [
    //           { id: 8, contractNo: 'HT20260515001', exceptionType: '付款延迟', exceptionContent: '客户未按时支付款项', createTime: '13:45', status: '未处理' }
    //         ],
    //         '2026-05-20': [
    //           { id: 9, contractNo: 'HT20260520001', exceptionType: '质量异常', exceptionContent: '产品质量检测不合格', createTime: '10:20', status: '处理中' }
    //         ],
    //         '2026-05-25': [
    //           { id: 10, contractNo: 'HT20260525001', exceptionType: '交付延迟', exceptionContent: '供应商延迟发货', createTime: '16:00', status: '未处理' }
    //         ]
    //       };
          
    //       resolve({
    //         data: exceptionData[date] || [],
    //         code: 200,
    //         message: 'success'
    //       });
    //     }, 100);
    //   });
    // },
    
    // 获取日期样式类
    getDayClass(day) {
      const classes = [];
      
      if (!day.isCurrentMonth) {
        classes.push('other-month');
      }
      
      // 今天
      // if (day.date === this.formatLocalDate(new Date())) {
      //   classes.push('today');
      // }
      
      // 选中的日期
      if (day.date === this.selectedDate) {
        classes.push('selected');
      }
      
      // 检查是否有异常合同
      if (this.getExceptionCount(day.date) > 0) {
        classes.push('has-exception');
      }
      
      return classes;
    },

    // 点击内容区域复制：优先合同号 → 任务号 → 项目编号
    copyTaskOrContractNo(item) {
      let text = '';
      if (item.contractNo) {
        text = item.contractNo;
      } else if (item.taskNo) {
        text = item.taskNo;
      } else if (item.projectNo) {
        // ✅ 合同号、任务号都没有时，复制当前展示的项目编号
        //    （否则显示的编号是项目号，点击却直接 return 没有任何反馈）
        text = item.projectNo;
      } else {
        return;
      }

      const doCopy = (val) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(val).then(() => {
            this.$message.success('已复制: ' + val);
          }).catch(() => {
            this.$message.error('复制失败');
          });
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = val;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          try {
            document.execCommand('copy');
            this.$message.success('已复制: ' + val);
          } catch (e) {
            this.$message.error('复制失败');
          }
          document.body.removeChild(textarea);
        }
      };

      doCopy(text);
    }
  },
  watch: {
    selectedDate(newVal) {
      if (newVal) {
        this.loadSelectedDateExceptionData();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.schedule-card-new {
  background-color: rgba(37, 100, 207, 0.06);
  border-radius: 5px;
  padding: 5px;
  width: 100%;
  // min-height: 120px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(37, 100, 207, 0.1);
  box-sizing: border-box;
  /* 第一行：时间选择框和年月显示 */
  .header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    margin-top: 0px;
    padding-bottom: 5px;
    padding-top: 0px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    
    .date-picker-section {
      ::v-deep .el-input__inner {
        height: 32px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        font-size: 13px;
        
        &:hover {
          border-color: #409EFF;
        }
      }
    }
    
    /* 修改：年月显示和切换控件 */
    .month-display {
      display: flex;
      align-items: center;
      gap: 0px;
      
      .current-month {
        font-size: 16px;
        font-weight: 700;
        color: #409EFF;
        font-family: "Microsoft YaHei-Bold", "Microsoft YaHei";
        min-width: 120px;
        text-align: center;
      }
      
      .nav-icon {
        font-size: 10px;
        color: #409EFF;
        cursor: pointer;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        transition: all 0.2s ease;
        
        &:hover {
          background-color: rgba(64, 158, 255, 0.1);
          transform: scale(1.1);
        }
        
        &:active {
          transform: scale(0.95);
        }
      }
    }
  }
  
  /* 主内容区域 */
  .main-content {
    display: flex;
    gap: 10px;
      max-height: 2200px;

    
    /* 左侧：月视图日历 */
    .calendar-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 280px;
      max-height: 180px;
      
      .weekdays {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 2px;
        margin-bottom: 5px;
        
        .weekday-cell {
          text-align: center;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.6);
          padding: 0 0;
          // padding: 4px 0;
          background-color: rgba(0, 0, 0, 0.02);
          border-radius: 4px;
        }
      }
      

// =====================日历区域详细格式====================================
    .calendar-grid {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      gap: 2px;
      flex: 1;

      .calendar-day {
        position: relative;
        min-height: 20px;
        border-radius: 4px;
        cursor: pointer;
        border: 1px solid transparent;
        transition: all 0.2s ease;
    /* ✅ 细边框（推荐） */
    border: 1px solid rgba(0, 0, 0, 0.08);

    /* ✅ 圆角（可选，更精致） */
    border-radius: 4px;

    /* ✅ 背景透明，交给状态控制 */
        /* ✅ 默认：当月无异常 */
        background-color: transparent;
        color: #303133;

        &:hover {
          background-color: rgba(64, 158, 255, 0.08);
        }

        /* ✅ 次月 */
        &.other-month {
          background-color: rgba(0, 0, 0, 0.02);
          color: rgba(0, 0, 0, 0.35);
        }
        /* ✅ 有异常 */
        &.has-exception {
          background-color: rgba(245, 108, 108, 0.1);
        }

        /* ✅ 选中 */
        &.selected {
          background-color: #409eff;
          color: #fff;
          font-weight: 600;
          box-shadow: 0 2px 6px rgba(64, 158, 255, 0.4);
          transform: translateY(-2px);
        }
        /* ✅ 选中 + 有异常 → 红色 */
        &.selected.has-exception {
          background-color: #f56c6c;
          box-shadow: 0 2px 6px rgba(245, 108, 108, 0.4);
        }

        /* ✅ 今天（不抢选中） */
        &.today {
          border: 1px solid #409eff;
          background-color: rgba(64, 158, 255, 0.06);
        }
      }
    }

    .day-circle {
      position: absolute;
      top: 2px;
      left: 4px;

      width: 18px;
      height: 18px;
      border-radius: 50%;

      font-size: 11px;
      font-weight: 500;

      display: flex;
      align-items: center;
      justify-content: center;

      transition: all 0.2s ease;
      z-index: 1;

      /* ✅ 默认（当月无异常） */
        // color: #fff;
        // background-color: #409effAa;



      /* ✅ 有异常 */
      &.has-exception {
        // background-color: #f56c6c;
        border-color: transparent;
        // color: #fff;
        font-weight: 600;
      }
      
      /* ✅ 次月 */
      &.other-month {
        color: rgba(0, 0, 0, 0.35);
      background-color: transparent;
        border-color: transparent; // ✅ 次月不要圈
      }


      /* ✅ 选中 */
      &.selected {
        background-color: #fff;
        color: #409eff;
        border-color: transparent;
      }

      /* ✅ 选中 + 异常 */
      &.selected.has-exception {
        background-color: #fff;
        color: #f56c6c;
      }

      /* ✅ 今天（未选中） */
      .calendar-day.today & {
        color: #409eff;
        font-weight: 600;
        border-color: #409eff;
      }
    }

.exception-count-text {
  position: absolute;
  right: 4px;
  bottom: 2px;

  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  z-index: 2;

  /* ✅ 默认红色 */
  color: #f56c6c;
}

/* ✅ 次月 */
::v-deep .calendar-day.other-month .exception-count-text {
  color: rgba(245, 108, 108, 0.6);
}

/* ✅ 今天 */
::v-deep .calendar-day.today .exception-count-text {
  color: #409eff;
}

/* ✅ 选中 → 白色（✅ 必杀） */
::v-deep .calendar-day.selected .exception-count-text {
  color: #fff !important;
}

/* ✅ 选中 + 有异常 → 白色 */
::v-deep .calendar-day.selected.has-exception .exception-count-text {
  color: #fff !important;
}
// =====================end日历区域详细格式====================================



      
      .legend {
        display: flex;
        justify-content: center;
        gap: 12px;
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px dashed rgba(0, 0, 0, 0.1);
        
        .legend-item {
          display: flex;
          align-items: center;
          gap: 4px;
          
          .legend-color {
            width: 12px;
            height: 12px;
            border-radius: 2px;
            display: inline-block;
            
            &.today-legend {
              background-color: #409EFF;
            }
            
            &.has-exception-legend {
              background-color: #f56c6c;
            }
            
            &.selected-legend {
              background-color: #409EFF;
            }
          }
          
          .legend-text {
            font-size: 10px;
            color: rgba(0, 0, 0, 0.6);
          }
        }
      }
    }
    
    /* 右侧：异常合同列表（样式保持不变） */
    /* ... 原有样式保持不变 ... */
    .exception-section {
      width: 420px;
      display: flex;
      flex-direction: column;
      border-left: 1px solid rgba(0, 0, 0, 0.1);
      padding-left: 20px;
      
      .exception-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        
        .selected-date {
          font-size: 14px;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
        }
        
        .exception-count {
          font-size: 12px;
          background-color: rgba(245, 108, 108, 0.1);
          color: #f56c6c;
          padding: 2px 8px;
          border-radius: 12px;
          font-weight: 600;
        }
      }
      
      .exception-list-container {
        flex: 1;
        overflow-y: auto;
        
        .exception-list {
          .exception-item {
            padding: 8px 10px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            cursor: pointer;
            transition: all 0.2s;
            
            &:hover {
              background-color: rgba(64, 158, 255, 0.05);
              border-radius: 4px;
            }
            
            &:last-child {
              border-bottom: none;
            }
            
            .item-main {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 4px;
              
              .contract-no {
                font-size: 12px;
                color: #409EFF;
                font-weight: 600;
                font-family: 'Consolas', 'Monaco', monospace;
              }
              
              .exception-type {
                font-size: 10px;
                background-color: rgba(245, 108, 108, 0.1);
                color: #f56c6c;
                padding: 1px 6px;
                border-radius: 10px;
              }
            }
            
            .item-sub {
              display: flex;
              justify-content: space-between;
              align-items: center;
              cursor: pointer;
              
              &:hover .exception-content {
                color: #409EFF;
              }
              
              .exception-content {
                font-size: 10px;
                color: rgba(0, 0, 0, 0.6);
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-right: 8px;
              }
              
              .create-time {
                font-size: 9px;
                color: rgba(0, 0, 0, 0.4);
              }
            }
          }
        }
        
        .no-exception {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100px;

          
          .no-exception-text {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.4);
          }
        }
      }
      
      .view-all-hint {
        text-align: center;
        font-size: 11px;
        color: rgba(64, 158, 255, 0.8);
        padding: 8px 0;
        cursor: pointer;
        border-top: 1px solid rgba(0, 0, 0, 0.05);
        transition: all 0.2s;
        
        &:hover {
          color: #409EFF;
          text-decoration: underline;
        }
      } 
    }   
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .schedule-card-new {
    .main-content {
      flex-direction: column;
      height: auto;
      gap: 5px;
      
      .calendar-section {
        min-width: auto;
        height: 180px;
          // max-height: 100px;
        
        /* 在小屏幕时隐藏异常数量徽章 */
        // .calendar-grid .calendar-day .exception-count-badge {
        //   display: none;
        // }
      }
      
      .exception-section {
        width: 100%;
        border-left: none;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        padding-left: 0;
        padding-top: 16px;
        
        .exception-list-container {
          max-height: 500px;
        }
        .exception-header {
          display: none;
        }
      }
    }
  }
}

// @media (max-width: 768px) {
//   .schedule-card-new {
//     /* 768px以下完全隐藏异常数量 */
//     // .calendar-grid .calendar-day .exception-count-badge {
//     //   display: none !important;
//     // }
//   }
// }

// @media (max-width: 600px) {
//   .schedule-card-new {
//     padding: 12px;
    
//     .header-row {
//       flex-direction: column;
//       align-items: flex-start;
//       gap: 8px;
      
//       .month-display {
//         width: 100%;
//         justify-content: center;
        
//         .current-month {
//           font-size: 16px;
//         }
        
//         .nav-icon {
//           width: 20px;
//           height: 20px;
//           font-size: 14px;
//         }
//       }
//     }
    
//     .main-content {
//       .calendar-section {
//         .calendar-grid {
//           .calendar-day {
//             min-height: 32px;
//             font-size: 11px;
            
//             .day-number {
//               font-size: 11px;
//               top: 1px;
//               left: 2px;
//             }
//           }
//         }
        
//         .legend {
//           flex-direction: column;
//           align-items: center;
//           gap: 6px;
//         }
//       }
//     }
//   }
// }
</style>


